import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

import { CompanyConfig } from "Models/company.config";
import { AppSwitch } from "Components/Generic/AppSwitch";

import {
  MandatoryFieldTitle,
  CustomerFieldsBox,
  CustomerFieldsItem,
  CustomerFieldsList,
} from "./styled";

type Props = {
  config: CompanyConfig["settings"]["opsAppConfiguration"]["propertyDamageReportConfig"];
  onConfigChange: (path: string, value: any) => void;
  disabled?: boolean;
};

export const OperationsAppSettingsPagePropertyDamageReportConfig = ({
  config,
  onConfigChange,
  disabled = false,
}: Props) => {
  const { t: translate } = useTranslation();

  return (
    <Box>
      <Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <MandatoryFieldTitle>{translate("requireCustomerInformationFields")}</MandatoryFieldTitle>
        </Box>

        <Box>
          <AppSwitch
            checked={!!config.requireCustomerInformationFields}
            disabled={disabled}
            onChange={(_, checked) =>
              onConfigChange(
                "settings.opsAppConfiguration.propertyDamageReportConfig.requireCustomerInformationFields",
                checked
              )
            }
          />
        </Box>
      </Box>

      <CustomerFieldsBox>
        <CustomerFieldsList>
          <CustomerFieldsItem>{translate("customerPhoneNumber")}</CustomerFieldsItem>
          <CustomerFieldsItem>{translate("alternativePhone")}</CustomerFieldsItem>
          <CustomerFieldsItem>{translate("email")}</CustomerFieldsItem>
          <CustomerFieldsItem>{translate("alternativeEmail")}</CustomerFieldsItem>
          <CustomerFieldsItem>{translate("mailingAddress")}</CustomerFieldsItem>
          <CustomerFieldsItem>{translate("city")}</CustomerFieldsItem>
          <CustomerFieldsItem>
            {translate("state")}/{translate("country")}
          </CustomerFieldsItem>
          <CustomerFieldsItem>{translate("postalCode")}</CustomerFieldsItem>
        </CustomerFieldsList>
      </CustomerFieldsBox>
    </Box>
  );
};
